import { useEffect, useMemo } from 'react';
import { AssetLoader } from '@mews/framework';

const FontProvider = () => {
    const fontName = 'inter';
    const fontAssetLoader = useMemo(() => new AssetLoader({ assetDirectory: `fonts/${fontName}` }), [fontName]);

    useEffect(() => {
        fontAssetLoader
            .initialize()
            .then(() => {
                const stylesheet = document.createElement('link');
                stylesheet.rel = 'stylesheet';
                stylesheet.type = 'text/css';
                stylesheet.href = fontAssetLoader.getAssetSrc(`${fontName}Font.css`);

                document.head.appendChild(stylesheet);
            })
            .catch((e: Error) => {
                throw e;
            });
    }, [fontAssetLoader, fontName]);

    return null;
};

export default FontProvider;
